<template>
    <div class="tables-basic">
        <div v-if="loading" class="page-loading-container">
            <b-spinner label="Loading..." ></b-spinner>
        </div>
        <div v-else>
            <h2 class="page-title">Largest Requests Across All Pages</h2>
            <Widget>
            <trend-graph :clickable="true" units="size" :options="trends"></trend-graph>
            </Widget>
            <b-row>
                <b-col>
                <div class="float-right" id="top">
                    <b-pagination-nav v-model="currentPage" :link-gen="linkGen()" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
                </div>
                </b-col>
            </b-row>
            <b-row v-if="selectedCrawlDate">

                <b-col>
                    <Widget :title="selectedCrawlDate"
                    >
                        <b-row >
                            <b-col lg="12" sm="12" xs="12">
                                <div class="table-responsive">
                                    <table class="table table-hover table-sm" >
                                        <thead>
                                        <tr>
                                            <th scope="col">Request</th>
                                            <th scope="col">Time</th>
                                            <th scope="col" nowrap>Size</th>
                                            <th scope="col">Pages</th>

                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="spelling" v-for="(request, index) in requests">
                                            <td width="75%" class="link-entry-ellipsis">
                                                <i style="color:gray" :class="iconClass(request)" :title="request.resource_type"></i> &nbsp; <a :href="request.url" target="_blank" title="External Link">{{request.url}}</a>
                                            </td>
                                            <td width="5%" style="vertical-align:middle"> <b-badge :variant="badgeVariant(request)">{{request.time | number('0')}}ms</b-badge>
                                            </td >
                                            <td nowrap>{{request.transfer_size | bytes}}</td>
                                            <td>
                                                <router-link :to="{ name: 'ExploreResourceDetails', query: {url: request.url, c: selectedCrawlId, source:'performance_network_slow'} }"><b><b-badge style="width:20px;padding: 0.4em 0.4em;" pill variant="secondary" :title="`Show pages.`"> {{request.pages.length}}</b-badge></b></router-link>
                                                </td>
                                        </tr>
                                        </tbody>
                                    </table>

                                </div>
                            </b-col>
                        </b-row>
                    </Widget>
                    <div class="float-right">
                        <b-pagination-nav v-model="currentPage" :link-gen="linkGen('#top')" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
  import Widget from '@/components/Widget/Widget';
  import DemoNotice from "@/components/DemoNotice/DemoNotice";
  import TrendGraph from "@/components/TrendGraph/TrendGraph";

  import gql from "graphql-tag";
  import { mapState } from 'vuex';
  import axios from "axios";
  export default {
    name: 'Tables',
    components: { Widget, DemoNotice, TrendGraph },
    apollo: {
      $subscribe: {
        selectedCrawl: {
          query() {
            return gql`subscription {
                  selectedCrawl:websites_crawl(where: {id: {_eq: ${this.selectedCrawlId}}}) {
                      id
                      started_at
                      status
                      websites_trends(where: {name: {_eq: "performance_network_size"}}){
                        id
                        data
                      }
                  }
          }`
          },
          skip () {
            return !this.activeSite.id || !this.selectedCrawlId;
          },
          result (data) {
            this.selectedCrawlDate = this.$moment(data.data.selectedCrawl[0].started_at).format('MMM D hh:mma');

            this.fullRequests = [];
            for (let entry of data.data.selectedCrawl[0].websites_trends[0].data){
              this.fullRequests.push({
                url: entry.url,
                time: entry.end_time - entry.start_time,
                pages: entry.pages,
                status_code: entry.status_code,
                resource_type: entry.resource_type,
                transfer_size: entry.transfer_size,
              })
            }
            this.numberOfPages = Math.floor(this.fullRequests.length / this.pageSize)
            this.requests = this.fullRequests.slice((this.currentPage-1) * this.pageSize, (this.currentPage) * this.pageSize)
          },

        },
        trends: {
          query() {
            return gql`subscription {
                  trends:websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                    websites_crawls {
                      id
                      started_at
                      websites_trends(where: {name: {_eq: "performance_network_size"}}) {
                        id
                        name
                        data_summary
                      }
                    }
                }
          }`
          },
          skip () {
            return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
          },
          result (data) {
            this.trends = {
              series:[],
              categories: [],
              categoryParams: [],
            };
            let series = [];
            for (let entry of data.data.trends[0].websites_crawls){
              if (!(entry.websites_trends && entry.websites_trends[0])){
                continue
              }
              for (const [key, _value] of Object.entries(entry.websites_trends[0].data_summary)) {
                if (!series.find((v)=>{return v.name === key})){
                  series.push({name: key, data:[]})
                }
              }
            }
            this.trends.series = series;
            for (let entry of data.data.trends[0].websites_crawls.reverse()){
              if (!(entry.websites_trends && entry.websites_trends[0])){
                continue
              }
              let summary = entry.websites_trends[0].data_summary;
              for (let serie of this.trends.series){
                if (summary[serie.name]){
                  serie.data.push(summary[serie.name].transfer_size)
                }
                else{
                  serie.data.push(0)
                }
              }
              this.trends.categoryParams.push(entry.id)
              this.trends.categories.push(new Date(entry.started_at).getTime())
            }
            if (!this.selectedCrawlId){
              this.selectedCrawlId = this.trends.categoryParams[this.trends.categoryParams.length-1]
            }
            this.loading = false;
            this.dataLoaded = true;
          },

        },
      }
    },
    data() {
      return {
        pages: [],
        selectedCrawlId: 0,
        selectedCrawlDate: 0,
        loading: true,
        dataLoaded: false,
        toastOptions: {
          theme: 'dark',
          position: 'bottomLeft',
        },
        links: [],
        requests: [],
        fullRequests: [],
        trends: [],
        currentPage: 1,
        numberOfPages: 2,
        pageSize: 25,
        row_selected: false,
      };
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Slowest Requests - PageWatch.dev',
      // all titles will be injected into this template
    },
    computed: {
      ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus", user: 'user'}),
    },
    watch: {
      'activeSite': function () {
        this.dataLoaded = false;
      }
    },
    methods: {
      badgeVariant(request){
        if (request.time > 1000){
          return 'danger';
        }
        if (request.time > 500){
          return 'warning'
        }
        return 'secondary'
      },
      iconClass(request){
        if (request.resource_type === 'Image'){
          return 'fa fa-image'
        }
        if (request.resource_type === 'Stylesheet'){

          return 'fa fa-css3'
        }
        if (request.resource_type === 'Script') {
          return 'fa fa-code'
        }
        if (request.resource_type === 'Font'){
          return 'glyphicon glyphicon-font'
        }

        return 'fi flaticon-network'
      },
      linkGen(hash) {
        if (!hash){
          hash = '';
        }
        return (pageNum) =>{
          return pageNum === 1 ? `?c=${this.selectedCrawlId}${hash}` : `?c=${this.selectedCrawlId}&page=${pageNum}${hash}`
        };
      },
      mouseOver(spellingError, index){
        spellingError.selectedPageIndex = index;
      },
    },
    created() {
      this.$watch("$route",() => {
        this.currentPage = this.$route.query.page || 1;
        this.dataLoaded = false;
        if (this.$route.query.c){
          this.selectedCrawlId = this.$route.query.c;
        }
        else{
          this.selectedCrawlId = (this.trends[this.trends.length-1] || {}).crawl || 0
        }
        this.requests = this.fullRequests.slice((this.currentPage-1) * this.pageSize, (this.currentPage) * this.pageSize)
      }, {
        immediate: true
      });
    }
  };
</script>

<style lang="scss">
    .link-redirect {
        font-size:9pt;
        color:gray;
        padding:4px;
    }
    .link-entry-ellipsis{
        max-width:580px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .broken-link-preview-image {
        border-radius: 50%;
        max-width: 250px;
        box-shadow: #bdc4e0 0px 0px 20px;
    }
</style>
